var Handlebars = require("handlebars/runtime");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"row\" id=\"reading-top-ad\">\n    <div class=\"reading-widget col-xs-12\"> \n        "
    + ((stack1 = (helpers.reactComponent || (depth0 && depth0.reactComponent) || helpers.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"AdContainer","reading-top",(depth0 != null ? depth0.readingTopProps : depth0),{"name":"reactComponent","hash":{},"data":data})) != null ? stack1 : "")
    + "\n    </div>\n</div>\n";
},"useData":true});